export default "__VITE_ASSET__DpNCVZit__"